import type { SelectItem } from '@/components/Atoms/FaceliftSelect/FaceliftSelect.types';
import { colors } from '@/components/ui/theme';

// Status code mappings with colors
export const STATUS_MAP: Record<number, { label: string; color: string }> = {
	1000: { label: 'Information Provided', color: colors.lightBlue },
	2000: { label: 'Merged', color: colors.nvisionPurple },
	1: { label: 'In Progress', color: colors.bvInProcess },
	2: { label: 'On Hold', color: colors.statusOrange },
	3: { label: 'Waiting for Details', color: colors.pendingYellow },
	4: { label: 'Researching', color: colors.lightBlue },
	5: { label: 'Problem Solved', color: colors.success },
	6: { label: 'Cancelled', color: colors.deniedRed },
};

// Priority code mappings with colors
export const PRIORITY_MAP: Record<number, { label: string; color: string }> = {
	1: { label: 'High', color: colors.deniedRed },
	2: { label: 'Normal', color: colors.lightBlue },
	3: { label: 'Low', color: colors.pendingYellow },
};

// Support Ticket Type Options (no duplication - unique to form)
export const typeOptions: SelectItem[] = [
	{ value: '953870000', label: 'Benefits Verification' },
	{ value: '953870005', label: 'Consignment' },
	{ value: '953870006', label: 'Documents' },
	{ value: '953870002', label: 'Orders' },
	{ value: '953870001', label: 'Patients' },
	{ value: '953870003', label: 'Payments' },
	{ value: '953870007', label: 'Tech' },
	{ value: '953870004', label: 'Utilities' },
	{ value: '2', label: 'Problem' },
	{ value: '1', label: 'Question' },
	{ value: '3', label: 'Request' },
];

// Generate priority options from PRIORITY_MAP
export const priorityOptions: SelectItem[] = Object.entries(PRIORITY_MAP).map(
	([value, data]) => ({
		value,
		label: data.label,
	}),
);

// Generate status options from STATUS_MAP
export const statusOptions: SelectItem[] = Object.entries(STATUS_MAP).map(
	([value, data]) => ({
		value,
		label: data.label,
	}),
);

// Status filter options for dropdown (includes Incomplete for null/undefined status)
export const statusFilterOptions = [
	{ label: 'All', value: '' },
	...statusOptions,
	{ label: 'Incomplete', value: 'incomplete' }, // NULL status
];

// Helper functions for data transformation
export const calculateDaysOpen = (createdon: string): number => {
	if (!createdon) return 0;
	const created = new Date(createdon);
	const now = new Date();
	const diffTime = Math.abs(now.getTime() - created.getTime());
	return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

export const mapPriority = (
	prioritycode: number | null | undefined,
): { label: string; color: string } => {
	if (!prioritycode) return PRIORITY_MAP[2]; // Default to Normal
	return PRIORITY_MAP[prioritycode] || PRIORITY_MAP[2];
};

export const mapStatus = (
	statuscode: number | null | undefined,
): { label: string; color: string } => {
	// Handle null or undefined status as "Incomplete"
	if (statuscode === null || statuscode === undefined) {
		return { label: 'Incomplete', color: colors.defaultGray };
	}
	return STATUS_MAP[statuscode] || STATUS_MAP[1];
};

export const mapType = (casetypecode: number | null | undefined): string => {
	if (!casetypecode) return '-';
	const typeOption = typeOptions.find((option) => option.value === String(casetypecode));
	return typeOption?.label || '-';
};

export const extractDocumentName = (url: string | null | undefined): string => {
	if (!url) return '---';

	try {
		const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
		const segments = cleanUrl.split('/');
		const lastSegment = segments[segments.length - 1];
		return decodeURIComponent(lastSegment) || '---';
	} catch (error) {
		console.error('Error extracting document name:', error);
		return '---';
	}
};



